// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"51e97f1e","359":"52fed600"}[chunkId] + ".chunk.js";
};